import { Pagination } from '@eventbrite/eds-pagination';
import { gettext } from '@eventbrite/i18n';
import { chunk, isEmpty, noop } from 'lodash';
import React, { useState } from 'react';
import { TrendingSearchResults } from '../types';
import { formatSearchUrl } from '../utils';

const TrendingSearches = ({
    searches,
    location,
    displayLocation,
    shouldNoFollowLinks,
    onClick,
    localeSubdirectory,
}: TrendingSearchResults) => {
    const _onClick = onClick || noop;
    const optionalLinkProps: { rel?: string } = {};
    const [page, setPage] = useState(1);
    let content;
    const maxResultsPerPage = 100;
    const pageCount = Math.ceil(searches.length / maxResultsPerPage);
    const searchChunk = chunk(searches, maxResultsPerPage);

    if (shouldNoFollowLinks) {
        optionalLinkProps.rel = 'nofollow';
    }

    if (searches.length > 0) {
        const pageIndex = page - 1;
        content = searchChunk[pageIndex].map((value, key) => (
            <div
                key={`${value.formatted}--${value.score}--${
                    pageIndex * maxResultsPerPage + key
                }`}
                className="eds-g-cell eds-g-cell-12-12 eds-g-cell-md-6-12 eds-g-cell-lg-4-12"
            >
                <p className="trending-search-result eds-l-pad-all-6 eds-l-mar-right-4">
                    <span className="eds-l-mar-right-3">
                        {pageIndex * maxResultsPerPage + key + 1}.
                    </span>
                    <a
                        href={formatSearchUrl(
                            location,
                            value.formatted,
                            localeSubdirectory,
                        )}
                        onClick={_onClick(value.term)}
                        {...optionalLinkProps}
                    >
                        {value.term}
                    </a>
                </p>
            </div>
        ));
    } else {
        content = (
            <div className="eds-g-cell eds-g-cell-12-12 eds-g-cell-md-12-12 eds-g-cell-lg-12-12">
                <p className="trending-search-result eds-l-pad-all-12 eds-l-mar-right-12">
                    {gettext('No trending searches for %(location)s.', {
                        location: displayLocation,
                    })}
                </p>
            </div>
        );
    }

    return (
        <div>
            <div
                id="trending-searches"
                className="eds-g-group trending-search-results"
            >
                {content}
            </div>
            {!isEmpty(searches) && (
                <div data-testid="trending-searches-pagination">
                    <Pagination
                        pageNumber={page}
                        pageCount={pageCount}
                        onSelected={(pageNumber: number) => setPage(pageNumber)}
                        resultsPerPage={maxResultsPerPage}
                        totalNumResults={searches.length}
                        showOnSinglePage={false}
                    />
                </div>
            )}
        </div>
    );
};

export default TrendingSearches;
